"use client";

import { useEffect } from "react";
import { supabase } from "@/lib/supabase";

export default function MarketingConsentBootstrap() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const pending = localStorage.getItem("pending_marketing_consent");
    if (pending === null) return;

    const consentValue = pending === "true";
    localStorage.removeItem("pending_marketing_consent");

    supabase.auth.getUser().then(({ data }) => {
      if (!data.user) return;

      const meta = data.user.user_metadata ?? {};
      if (meta.marketing_consent !== undefined) return;

      void supabase.auth.updateUser({
        data: {
          marketing_consent: consentValue,
          marketing_consent_date: consentValue
            ? new Date().toISOString()
            : null,
        },
      });
    });
  }, []);

  return null;
}